module.exports = __webpack_public_path__ + "img/hezuo@2x.45fec080.png";